export default __webpack_public_path__ + "static/media/manual.e47309ee.pdf";